
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleet as ObiLightningLightSleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet.js';
 
 
 

 
 export const ObiLightningLightSleet = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet',
   elementClass: ObiLightningLightSleetElement,
   events: {
     
   }
  });
 
 